/* eslint-disable max-lines */
import { useChatApi } from '../api/useChatApi';
import { useChatContext } from '../context/ChatProvider/hooks/useChatContext';
import { useFetch } from './useFetch';

export const useQuestion = () => {
  const { fetchInstance } = useFetch();
  const { updateHistory, updateStreamingHistory } = useChatContext();
  const { addQuestion } = useChatApi();

  const addQuestionHandler = async (
    chatId,
    chatQuestion,
  ) => {
    const response = await addQuestion({
      chatId,
      chatQuestion,
    });

    updateHistory(response);
  };

  const handleStream = async (
    reader,
  ) => {
    const decoder = new TextDecoder('utf-8');

    const handleStreamRecursively = async () => {
      const { done, value } = await reader.read();

      if (done) {
        return;
      }

      const dataStrings = decoder
        .decode(value)
        .trim()
        .split('data: ')
        .filter(Boolean);

      dataStrings.forEach((data) => {
        try {
          const parsedData = JSON.parse(data);
          updateStreamingHistory(parsedData);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error parsing data', error);
        }
      });

      await handleStreamRecursively();
    };

    await handleStreamRecursively();
  };

  const addStreamQuestion = async (
    chatId,
    chatQuestion,
  ) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
    };
    const body = JSON.stringify(chatQuestion);
    try {
      const response = await fetchInstance.post(
        `/chat/${chatId}/question/stream`,
        body,
        headers,
      );

      if (response.body === null) {
        throw new Error('Responde body is null');
      }

      await handleStream(response.body.getReader());
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error calling the API', error);
    }
  };

  return {
    addQuestion: addQuestionHandler,
    addStreamQuestion,
  };
};

export default useQuestion;
